var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"opentab",attrs:{"type":"md-menu","size":"28"},on:{"click":_vm.openMenuList}})
}
var staticRenderFns = []

export { render, staticRenderFns }